module.exports = __webpack_public_path__ + "static/fonts/D-DIN-PRO-400-Regular.otf";